<mat-toolbar class="mat-elevation-z3">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <img
    src="https://www.mitfuso.com/images/logos/fuso-logo.svg"
    alt="Logo: Fuso"
    class="logo-icon"
    width="42px"
  />
  <div
    fxLayout="row"
    style="height: inherit; text-align: center; width: 100%"
    fxLayoutAlign="center center"
    fxLayoutGap="10px"
  >
    <span class="mat-display-1">{{ componentName | uppercase }}</span>
  </div>
</mat-toolbar>
